import React from "react";

/**
 * Single-value dial for the headline score of a report — the wellness index or
 * the índice deportivo.
 *
 * A ring is used rather than a bar because this number has a fixed 0-100
 * domain and no comparison partner: the reader needs "how full is it", not
 * "how does it rank". The value is also printed as text inside the ring so the
 * chart is never the only carrier of the number.
 */
const Ring = ({ value, color = "#2351ac", caption, suffix = "%", size = 200 }) => {
  const radius = 78;
  const circumference = 2 * Math.PI * radius;
  const hasValue = typeof value === "number" && Number.isFinite(value);
  const filled = hasValue ? Math.max(0, Math.min(100, value)) : 0;

  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      width="100%"
      role="img"
      aria-label={hasValue ? `${caption || "Indicador"}: ${value}${suffix}` : "Sin datos suficientes"}
    >
      <circle cx="100" cy="100" r={radius} fill="none" stroke="#e9edf6" strokeWidth="17" />
      {hasValue && (
        <circle
          cx="100"
          cy="100"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="17"
          strokeLinecap="round"
          strokeDasharray={`${(circumference * filled) / 100} ${circumference}`}
          transform="rotate(-90 100 100)"
        />
      )}
      <text
        x="100"
        y={hasValue ? 104 : 100}
        textAnchor="middle"
        fontFamily="Yanone Kaffeesatz, sans-serif"
        fontSize={hasValue ? 52 : 26}
        fill="#0d1e41"
      >
        {hasValue ? `${value}${suffix}` : "Sin datos"}
      </text>
      {caption && (
        <text
          x="100"
          y="126"
          textAnchor="middle"
          fontSize="11.5"
          fill={hasValue ? color : "#7692d1"}
          fontFamily="Poppins, sans-serif"
        >
          {caption}
        </text>
      )}
    </svg>
  );
};

export default Ring;
